define('SuiteDynamics.HeaderProfileExtension.CartChanges',
    [
        'Utils'
    ],
    function (
        Utils
    )
{
    'use strict';

    return  {
        mountToApp: function mountToApp (container) {
            var layout = container.getComponent('Layout');
            var cart = container.getComponent('Cart');
            if (layout && cart && Utils.isShoppingDomain()) {
                layout.addToViewContextDefinition('Cart.Summary.View', 'hidePromocodeForm', 'boolean', function () {
                    return Utils.isShoppingDomain();
                });
            }
        }
    }
})
